import { UnitPlanPromptNames } from '@lessonPlanner/constants';

export const PROMPT_ACTION = {
  examples: 'examples',
  elaborate: 'elaborate',
};

export const PROMPT_TO_BE_USED = {
  examples: 'respondMoreExamples',
  elaborate: 'respondElaboration',
  continuation: 'continuation',
  matatagContinuation: 'matatagContinuation',
};

export const TARGET_SECTION = {
  EXPLORE: 'Explore:',
  ELABORATE: 'Elaborate:',
  ACTIVITY: 'Activity:',
  PAGTUKLAS: 'Pagtuklas:',
  AKTIBIDAD: 'Aktibidad:',
};

export const ANCHOR_KEYWORD = {
  ANALYSIS: 'Analysis:',
  EXPLAIN: 'Explain:',
  PAGKASURI: 'Pagkasuri',
  PAGKASURI_WITH_ENG: 'Pagkasuri (Analysis):',
  PALIWANAG: 'Paliwanag',
  PALIWANAG_WITH_ENG: 'Paliwanag (Explain):',
};

export enum LessonFormat {
  CODE_4A = '4As/5As',
  CODE_5E = '5Es',
  CODE_7E = '7Es',
  CODE_M = 'MATATAG',
}

export enum CerebroLessonFormat {
  CODE_A = 'Cerebro Lesson Plan',
  CODE_B = 'Teaching Guide',
  CODE_C = 'Learning Companion',
}

export const MODAL_TITLE = {
  LP: `Here's your Lesson Plan!`,
  LC: `Here's your Objectives!`,
  QMS: `Here's your Quiz!`,
  AC: `Here's your Activity!`,
  SE: `Here's your Learnings Across the Curriculum!`,
  ANLG: `Here's your Analogy!`,
  ST: `Here's your Summative Test!`,
  CLP: `Here's your Cerebro Teaching Guide!`,
  DLL: `Here's your Daily Lesson Log!`,
  CUF: `Here's your Catch-Up Fridays!`,
  EN: `Here's your Energizer!`,
  ELIF: `Here's your Result!`,
  TE: `Here's your Explored Topic!`,
  PHOTO_BOOTH: `Here's your Photo!`,
  UP: `Here's your Unit Plan!`,
  PPT: `Here's your PPT!`,
};

export const Abstraction = 'Abstraction:';
export const Application = 'Application:';
export const Elaborate = 'Elaborate:';
export const Assessment = 'Assessment - Evaluating Learning:';
export const Paglalapat = 'Paglalapat:';
export const PaglalapatApplication = 'Paglalapat (Application):';
export const Pagpapalawak = 'Pagpapalawak:';
export const PagpapalawakElaborate = 'Pagpapalawak (Elaborate):';
export const References = 'END OF REFERENCES';
export const PostTest = 'POST TEST';

export const PAGE_TITLE = {
  LP: `Lesson Plan`,
  LC: `Objectives`,
  QMS: `Quiz`,
  AC: `Activity`,
  SE: `Learnings Across the Curriculum`,
  ANLG: `Analogy`,
  ST: `Summative Test`,
  CLP: `Cerebro Lesson Plan`,
  DLL: `Daily Lesson Log`,
  CUF: `Catch-Up Fridays`,
  TE: `Topic Explorer`,
  EN: `Energizer`,
  ELIF: `Explain Like I'm 5`,
  PHOTO_BOOTH: `Photo Booth`,
  UP: `Unit Plan`,
  PPT: `Powerpoint Maker`,
};

export const MATATAG_SECTIONS = [
  'Before/Pre-lesson Proper',
  'Activating Prior Knowledge',
  'Lesson Purpose / Intention',
  'Lesson Language Practice',
  'During / Lesson Proper',
  'Reading the Key Idea',
  'Developing Understanding of the Key Idea',
  'Deepening Understanding of the Key Idea',
  'After/Post-Lesson Proper',
  'Making Generalizations and Abstractions',
  'Evaluating Learning',
  'Additional Activities for Application or Remediation',
];

export const DLL_SECTIONS = [
  'Filipino DLL',
  'Asignatura',
  'Antas Baitang',
  'I. Layunin',
  'Pamantayang Pangnilalaman',
  'Pamantayan sa Pagganap',
  'Mga Kasanayan sa Pagkatuto',
  'II. NILALAMAN',
  'III. KAGAMITANG PANTURO',
  'A. Sanggunian',
  'Mga Pahina sa Gabay ng Guro',
  'Mga Pahina sa Kagamitang Pang-Mag-aaral',
  'Mga Pahina sa Teksbuk',
  'Karagdagang Kagamitan mula sa portal ng Learning Resource',
  'B. Iba pang Kagamitang Panturo',
  'PAMAMARAAN',
  'Balik-Aral sa Nakaraang Aralin at/o Pagsisimula ng Bagong Aralin',
  'Paghahabi sa Layunin ng Aralin',
  'Pag-uugnay ng mga Halimbawa sa Bagong Aralin',
  'Pagtalakay ng bagong konsepto at pagsasanay ng bagong kasanayan #1:',
  'Pagtalakay ng bagong konsepto at pagsasanay ng bagong kasanayan #2:',
  'Paglinang sa Kabihasaan',
  'Paglalapat ng Aralin sa Pang-Araw-araw na Buhay',
  'Paglalahat ng Aralin',
  'Pagtataya ng Aralin',
  'Karagdagang Gawain para sa Takdang-Aralin at Remediation',

  'PROCEDURES',
  'Reviewing previous lesson or presenting the new lesson',
  'Establishing purpose for the lesson',
  'Presenting examples / instances of the new lesson',
  'Discussing new concepts and practicing new skills #1',
  'Discussing new concepts and practicing new skills #2',
  'Developing mastery',
  'Finding practical applications of concepts and skills in daily living',
  'Making generalizations and abstractions about the lesson',
  'Evaluating learning',
  'Additional activities for application or remediation',
];

export const UNIT_PLAN_SECTIONS = {
  [UnitPlanPromptNames.PYP]: [
    'Transdisciplinary Theme',
    'Central Idea',
    'Lines of Inquiry',
    'Key Concepts',
    'Related Concepts',
    'Learner profile attributes',
    'Approaches to Learning (ATL)',
    'Learning Goals',
    'Inquiry Questions',
    'Teaching Learning Activities',
    'Assessment',
    'References',
    'Action',
    'Reflection',
  ],
  [UnitPlanPromptNames.MYP]: [
    'Key Concept',
    'Related Concepts',
    'Global Context',
    'Statement of Inquiry',
    'Inquiry Questions',
    'Learner profile attributes',
    'Approaches to Learning (ATL)',
    'Learning Goals',
    'Interdisciplinary Connections',
    'Teaching Learning Activities',
    'Differentiation',
    'Assessment',
    'Service as Action',
    'References',
    'Reflection',
  ],
  [UnitPlanPromptNames.DP]: [
    'Key Concepts',
    'Related Concepts',
    'Theory of Knowledge (TOK) Connections',
    'International-Mindedness',
    'Inquiry Questions',
    'Learner profile attributes',
    'Approaches to Learning (ATL)',
    'Learning Goals & Assessment Objectives',
    'Interdisciplinary Connections',
    'Teaching Learning Activities',
    'Differentiation',
    'Assessment',
    'Real-world Applications',
    'References',
    'Reflection',
  ],
};

export const DEFAULT_LESSON_PLAN_SECTION = [
  'I. General Information:',
  'II. Learning Objectives:',
  'III. Lesson Preparation:',
  'IV. Instructional Design:',
  'V. Application:',
  'VI. Evaluation:',
];

export const DEFAULT_ACTIVITY_SECTION = [
  'Activity:',
  'Introduction:',
  'Significance:',
  'Teaching Strategy:',
  'Materials:',
  'Detailed Instructions:',
  'Example Run-through:',
  'Assessment Questions:',
  'Pre-Activity Rationale:',
  'Post-Activity Rationale and Analysis:',
];
